import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

const config = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}` },
});

const url = (bookingId) => `${API_BASE_URL}/api/admin/bookings/${bookingId}/transport-payments`;

// vehicle: 1 is the booking's own vehicle, 2 and up the vehicles added on request. Each vehicle's
// vendor has its own payable and payments.
const withVehicle = (vehicle) => ({ ...config(), params: { vehicle: Number(vehicle) || 1 } });

export const getBookingTransportPayments = async (bookingId, vehicle = 1) =>
  (await axios.get(url(bookingId), withVehicle(vehicle))).data;

export const saveBookingTransportPayable = async (bookingId, totalPayable, vehicle = 1) =>
  (await axios.put(`${url(bookingId)}/payable`, { totalPayable }, withVehicle(vehicle))).data;

// Drops a hand-entered amount and tracks the quoted vehicle cost again.
export const followQuoteBookingTransportPayable = async (bookingId, vehicle = 1) =>
  (await axios.put(`${url(bookingId)}/payable`, { followQuote: true }, withVehicle(vehicle))).data;

export const recordBookingTransportPayment = async (bookingId, payment, vehicle = 1) =>
  (await axios.post(url(bookingId), payment, withVehicle(vehicle))).data;

// Corrections need a reason; a delete keeps the payment on record but out of every total. The
// server knows which vehicle a payment was for.
export const editBookingTransportPayment = async (bookingId, paymentId, change) =>
  (await axios.put(`${url(bookingId)}/${paymentId}`, change, config())).data;

export const deleteBookingTransportPayment = async (bookingId, paymentId, reason) =>
  (await axios.post(`${url(bookingId)}/${paymentId}/delete`, { reason }, config())).data;
